import { Pipe } from '@angular/core';
var JhiTruncateCharactersPipe = /** @class */ (function () {
    function JhiTruncateCharactersPipe() {
    }
    JhiTruncateCharactersPipe.prototype.transform = function (input, chars, breakOnWord) {
        if (isNaN(chars)) {
            return input;
        }
        if (chars <= 0) {
            return '';
        }
        if (input && input.length > chars) {
            input = input.substring(0, chars);
            if (!breakOnWord) {
                var lastspace = input.lastIndexOf(' ');
                // Get last space
                if (lastspace !== -1) {
                    input = input.substr(0, lastspace);
                }
            }
            else {
                while (input.charAt(input.length - 1) === ' ') {
                    input = input.substr(0, input.length - 1);
                }
            }
            return input + '...';
        }
        return input;
    };
    JhiTruncateCharactersPipe.decorators = [
        { type: Pipe, args: [{ name: 'truncateCharacters' },] },
    ];
    return JhiTruncateCharactersPipe;
}());
export { JhiTruncateCharactersPipe };



//////////////////
// WEBPACK FOOTER
// ./~/ng-jhipster/src/pipe/truncate-characters.pipe.js
// module id = 1742
// module chunks = 1